import Link from 'next/link'
import Image from 'next/image'
import styles from './CategoryCard.module.scss'
import { memo } from 'react'
// Utils
import { convertCategory } from '../search/lib/utils'
import { rgbDataURL } from '../puppyProfile/lib/utils'
import { altTextMap } from './lib/utils'

interface CategoryCardProps {
  c: string
  isLanding: boolean
}

const CategoryCard = memo(({ c, isLanding }: CategoryCardProps) => {
  return (
    <Link
      href={isLanding ? `/puppies-for-sale/${c}` : `/search?category=${c}`}
      className={styles.category}
    >
      <div className={styles.image}>
        <Image
          height={230}
          width={340}
          src={`/${c}.png`}
          className={styles.image}
          blurDataURL={rgbDataURL(238, 238, 238)}
          alt={altTextMap[c] || 'Dog Category Image'}
        />
      </div>
      <div className={styles.footer}>
        <div
          className={styles.icon}
          style={{ backgroundImage: `url(/${c}.svg)` }}
        />
        <p>{convertCategory(c)}</p>
      </div>
    </Link>
  )
})

export default CategoryCard
